<template>
  <div
    v-if="modal"
    class="wrapper"
  >
    <div class="card mx-auto">
      <div class="d-flex justify-content-end pt-5 pr-2 p-lg-2">
        <img
          src="@/assets/icon/close.png"
          alt="close"
          class="pointer"
          @click="$emit('close', 'edit')"
        >
      </div>
      <div class="px-5 py-3">
        <h5 class="pb-2 font-weight-bold border-bottom">
          {{ $t("user-profile.header.update") }}
        </h5>
      </div>
      <div
        v-if="isLoadingForm"
        class="d-flex justify-content-center text-info card-body"
      >
        <div class="spinner-border spinner-border-sm">
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
      <div
        v-else
        class="card-body overflow-auto px-5"
      >
        <div class="d-flex justify-content-center">
          <div class="parent-button">
            <div class="children-button">
              <input
                id="file"
                ref="file"
                type="file"
                accept="image/*"
                @change="onFileChange"
              >
              <label for="file">
                <img src="@/assets/icon/change-photo.png">
              </label>
            </div>
            <img
              v-if="!form.avatar && !avatar.url"
              src="@/assets/icon/guest.png"
              class="image-width"
              alt="profile-icon"
            >
            <img
              v-if="!form.avatar && avatar.url"
              :src="avatar.url"
              class="image-width rounded-circle"
              alt="profile-icon"
            >
            <img
              v-if="form.avatar && !avatar.url"
              :src="form.avatar"
              class="image-width rounded-circle"
              alt="profile-icon"
            >
            <img
              v-if="form.avatar && avatar.url"
              :src="avatar.url"
              class="image-width rounded-circle"
              alt="profile-icon"
            >
          </div>
        </div>
        <div
          v-if="!form.isActiveDirectory"
          class="mt-3 text-center"
        >
          <div
            class="col-sm-3 btn btn-info"
            data-toggle="modal"
            data-target="#modalPassword"
            @click="showModal('password')"
          >
            <small class="font-weight-bold">
              {{ $t("user-profile.button.password") }}
            </small>
          </div>
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t("user-profile.head.personal") }}
          </h6>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.username")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <input
                v-model="form.username"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': $v.form.username.$error }"
                :disabled="form.isActiveDirectory"
              >
              <div
                v-if="!$v.form.username.required && $v.form.username.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.username") }}
                </small>
              </div>
              <div
                v-if="!$v.form.username.maxLength"
                class="text-danger"
              >
                <small>
                  {{ $t("registration.form-error.username-maxlength") }}
                </small>
              </div>
              <div
                v-if="!$v.form.username.alpha"
                class="text-danger"
              >
                <small>
                  {{ $t("registration.form-error.username-alpha") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.fullname")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <input
                v-model="form.fullname"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': $v.form.fullname.$error }"
                :disabled="form.isActiveDirectory"
              >
              <div
                v-if="!$v.form.fullname.required && $v.form.fullname.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.fullname") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.birthdate")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <div class="input-group">
                <div
                  class="form-control form-control-sm"
                  disabled
                  :class="{
                    'bg-white': !form.hrisEmpId,
                    'bg-secondary': form.hrisEmpId,
                    'is-invalid': $v.form.birthdate.$error
                  }"
                >
                  {{
                    form.birthdate
                      ? getAge() + " / " + form.birthdate
                      : "age/yyyy-mm-dd"
                  }}
                </div>
                <div class="pointer input-group-prepend">
                  <date-picker
                    v-if="!form.hrisEmpId"
                    v-model="form.birthdate"
                    :model-config="modelConfig"
                    class="date-pick"
                    :max-date="today"
                  >
                    <template v-slot="{ togglePopover }">
                      <span
                        class="input-group-text bg-white text-info rounded-left"
                        @click="togglePopover({ placement: 'auto-start' })"
                      >
                        <i
                          class="fa fa-calendar"
                          aria-hidden="true"
                        />
                      </span>
                    </template>
                  </date-picker>
                </div>
              </div>
              <div
                v-if="!$v.form.birthdate.required && $v.form.birthdate.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.birthdate") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.gender")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.gender"
                :options="gender"
                :get-option-label="getLabelGender"
                :clearable="false"
                :disabled="form.hrisEmpId ? true : false"
                :reduce="getReduceId"
                :class="{ 'border border-danger': $v.form.gender.$error }"
              />
              <div
                v-if="!$v.form.gender.required && $v.form.gender.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.gender") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.email")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <input
                v-model="form.email"
                type="text"
                class="form-control form-control-sm"
                :disabled="form.isActiveDirectory"
                :class="{ 'is-invalid': $v.form.email.$error }"
              >
              <div
                v-if="!$v.form.email.required && $v.form.email.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.email") }}
                </small>
              </div>
              <div
                v-if="!$v.form.email.email && $v.form.email.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.email-wrong") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.address")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <input
                v-model="form.address"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': $v.form.address.$error }"
              >
              <div
                v-if="!$v.form.address.required && $v.form.address.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.address") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.phone")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <input
                v-model="form.phoneNumber"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': $v.form.phoneNumber.$error }"
              >
              <div
                v-if="
                  !$v.form.phoneNumber.required && $v.form.phoneNumber.$error
                "
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.phone-number") }}
                </small>
              </div>
              <div
                v-if="
                  !$v.form.phoneNumber.numeric && $v.form.phoneNumber.$error
                "
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.phone-number-numeric") }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t("user-profile.head.organization") }}
          </h6>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.company-default")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.companyGroup"
                class="sm"
                :class="{ 'border border-danger': $v.form.companyGroup.$error }"
                :options="companyType"
                :get-option-label="getCompanyLabel"
                :reduce="getReduceValue"
                :clearable="false"
                :disabled="form.isActiveDirectory"
              />
              <div
                v-if="
                  !$v.form.companyGroup.required && $v.form.companyGroup.$error
                "
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.company") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.company-itm")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.company.id"
                class="sm"
                :class="{ 'border border-danger': $v.form.company.id.$error }"
                label="name"
                :options="dataApi.company"
                :reduce="getReduceId"
                :clearable="false"
                :disabled="form.hrisEmpId ? true : false"
              />
              <div
                v-if="!$v.form.company.id.required && $v.form.company.id.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.company") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.organization")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.workLocationId"
                class="sm"
                label="name"
                :options="dataApi.organization"
                :reduce="getReduceId"
                :clearable="false"
                :disabled="form.hrisEmpId"
              />
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.work-location")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.workLocationActual"
                class="sm"
                :class="{
                  'border border-danger': $v.form.workLocationActual.$error
                }"
                label="name"
                :options="dataApi.workLocationActual"
                :clearable="false"
                :reduce="getReduceName"
                :selectable="getSelectableGroup"
              >
                <template #option="{ group, name }">
                  <div v-if="group">
                    {{ group }}
                  </div>
                  {{ name }}
                </template>
              </v-select>
              <div
                v-if="
                  !$v.form.workLocationActual.required &&
                    $v.form.workLocationActual.$error
                "
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.work-location") }}
                </small>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.contractor")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.contractorId"
                class="sm"
                label="name"
                :options="dataApi.contractors"
                :clearable="false"
                :reduce="getReduceId"
                :disabled="form.hrisEmpId ? true : false"
              />
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.nik")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-4">
              <input
                v-model="form.nric"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': $v.form.nric.$error }"
                :disabled="form.hrisEmpId ? true : false"
              >
              <div
                v-if="!$v.form.nric.required && $v.form.nric.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.nric") }}
                </small>
              </div>
            </div>
            <div class="col-sm-3">
              <div
                v-if="form.hrisEmpId"
                class="d-flex justify-content-between my-1"
              >
                <div class="text-success">
                  <small class="font-weight-bold">
                    HRIS Linkage
                  </small>
                </div>
                <img
                  src="@/assets/icon/checklist-green.png"
                  alt="checklist-green"
                >
              </div>
              <div
                v-if="!form.hrisEmpId"
                class="d-flex justify-content-between my-1"
              >
                <div class="text-danger">
                  <small class="font-weight-bold">
                    HRIS Linkage
                  </small>
                </div>
                <img
                  src="@/assets/icon/close.png"
                  alt="wrong"
                >
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.work-unit")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5">
              <v-select
                v-model="form.workUnit"
                class="sm"
                :class="{ 'border border-danger': $v.form.workUnit.$error }"
                label="workUnitName"
                :options="dataApi.workUnit"
                :reduce="getWorkUnitName"
                :clearable="false"
                :disabled="form.hrisEmpId ? true : false"
              />
              <div
                v-if="!$v.form.workUnit.required && $v.form.workUnit.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.work-unit") }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-4">
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t("user-profile.head.other") }}
          </h6>
          <div class="row pb-2">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.status")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 mt-2">
              <toggle-button
                :value="form.isActive"
                @change="form.isActive = !form.isActive"
              />
            </div>
          </div>
          <div class="row pb-2">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.comorbid")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div class="col-sm-5 mt-2">
              <toggle-button
                :value="form.comorbid"
                @change="form.comorbid = !form.comorbid"
              />
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-sm-4 col-lg-4 pt-sm-1">
              <small class="font-weight-bold">{{
                $t("user-profile.label.role")
              }}</small>
            </div>
            <div class="col-sm-1 col-lg-1 d-none d-sm-block pt-sm-1">
              :
            </div>
            <div
              v-if="
                profile.role.name === 'Administrator' ||
                  profile.role.name === 'Administrator Site'
              "
              class="col-sm-5"
            >
              <v-select
                v-if="
                  profile.role.name === 'Administrator Site' &&
                    (form.role.name === 'Administrator' ||
                      form.role.name === 'Administrator Custom')
                "
                v-model="form.role.name"
                class="sm"
                disabled
                :clearable="false"
              />
              <v-select
                v-else
                v-model="form.roleId"
                class="sm"
                :class="{ 'border border-danger': $v.form.roleId.$error }"
                label="name"
                :options="dataApi.role"
                :reduce="getReduceId"
                :clearable="false"
              />
              <div
                v-if="!$v.form.roleId.required && $v.form.roleId.$error"
                class="text-danger"
              >
                <small>
                  {{ $t("user-profile.form.invalid.role") }}
                </small>
              </div>
            </div>
            <div
              v-else
              class="col-sm-5"
            >
              <v-select
                v-model="form.role.name"
                class="sm"
                :clearable="false"
                disabled
              />
            </div>
          </div>
        </div>
        <div
          v-if="
            form.roleId === '23dc156d-5550-419a-a2e8-6bab249a8493' &&
              profile.role.name === 'Administrator'
          "
          class="pt-4"
        >
          <h6 class="mb-3 font-weight-bold text-info p-0 border-bottom">
            {{ $t("user-profile.head.role") }}
          </h6>
          <div class="role-card px-3">
            <div class="overflow-auto">
              <div class="table-height">
                <table
                  class="table table-striped table-wrapper table-borderless"
                >
                  <thead>
                    <tr class="row">
                      <th class="bg-white in-front-of col-4 pl-4">
                        <small class="font-weight-bold">
                          {{ $t("user-profile.label.company-itm") }}
                        </small>
                      </th>
                      <th class="bg-white in-front-of col-3 pl-4">
                        <small class="font-weight-bold">
                          {{ $t("user-profile.label.organization") }}
                        </small>
                      </th>
                      <th class="bg-white in-front-of col-4 pl-4">
                        <small class="font-weight-bold">
                          {{ $t("user-profile.label.contractor-name") }}
                        </small>
                      </th>
                      <th class="bg-white in-front-of col-1 pl-4">
                        <small class="font-weight-bold">
                          {{ $t("user-profile.label.action") }}
                        </small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(role, i) in customRole"
                      :key="i"
                      class="row"
                    >
                      <td class="col-4 pl-4">
                        <v-select
                          v-model="role.companyNew"
                          class="sm"
                          label="name"
                          :placeholder="$t('user-profile.placeholder.company')"
                          :options="dataApi.companyRole"
                          :reduce="getReduceId"
                          :clearable="false"
                          :class="{
                            'border border-danger rounded':
                              $v.customRole.$each.$iter[i].$error
                          }"
                          :selectable="option => !option.hide"
                          @input="updateField(i, role.companyNew)"
                        />
                        <div
                          v-if="
                            !$v.customRole.$each.$iter[i].required &&
                              $v.customRole.$each.$iter[i].$error
                          "
                          class="text-danger"
                        >
                          <small class="font-weight-bold">
                            {{ $t("user-profile.form.invalid.company") }}
                          </small>
                        </div>
                      </td>
                      <td class="col-3 pl-4">
                        <v-select
                          v-model="role.organization"
                          class="sm"
                          multiple
                          label="name"
                          :placeholder="
                            $t('user-profile.placeholder.organization')
                          "
                          :reduce="getReduceId"
                          :options="role.dataApi.organization"
                          :disabled="role.dataApi.organization.length === 0"
                          :clearable="false"
                        />
                      </td>
                      <td class="col-4 pl-4">
                        <v-select
                          v-model="role.contractorName"
                          class="sm"
                          label="name"
                          multiple
                          :placeholder="
                            $t('user-profile.placeholder.contractor-name')
                          "
                          :reduce="getReduceId"
                          :options="role.dataApi.contractorName"
                          :disabled="role.dataApi.contractorName.length === 0"
                          :clearable="false"
                        />
                      </td>
                      <td class="col-1 pl-4 text-center">
                        <img
                          src="@/assets/icon/delete.png"
                          class="pointer"
                          alt="delete"
                          @click="deleteCustomRole(i, role.companyNew)"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div
                class="col-sm-3 btn btn-info py-2 px-4 d-flex justify-content-between"
                @click="addCustomRole"
              >
                <div>
                  <img
                    src="@/assets/icon/add-white.png"
                    alt="add"
                  >
                </div>
                <div>
                  <small class="font-weight-bold">
                    {{ $t("user-profile.button.add") }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4 mb-3">
        <div
          class="col-sm-2 btn btn-outline-info mx-2"
          @click="$emit('close', 'edit')"
        >
          <small class="font-weight-bold">
            {{ $t("user-profile.button.cancel") }}
          </small>
        </div>
        <div
          v-if="!isLoadingSave"
          class="col-sm-2 btn btn-info mx-2"
          @click="submit"
        >
          <small class="font-weight-bold">
            {{ $t("user-profile.button.save") }}
          </small>
        </div>
        <div
          v-if="isLoadingSave"
          class="col-sm-2 btn btn-info mx-2 text-center"
        >
          <div class="spinner-border spinner-border-sm">
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess
      v-if="modalEdit.success"
      :text-modal="modalEdit.textModal"
      @closeModal="closeModal"
    />
    <ModalUnsuccessful
      v-if="modalEdit.unsuccessful"
      :text-modal="modalEdit.textModal"
      @closeModal="closeModal"
    />
    <ModalPassword :id="form.id" />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { format, differenceInYears } from 'date-fns'
import VSelect from 'vue-select'
import { GENDER, COMPANY_TYPE } from '@/fixtures'
import { ToggleButton } from 'vue-js-toggle-button'
import {
  requiredIf,
  required,
  email,
  numeric,
  helpers,
  minLength,
  maxLength,
  alpha
} from 'vuelidate/lib/validators'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalPassword from '@/components/modal/password/ModalPassword'

const validateIf = (prop1, prop2, validator) =>
  helpers.withParams({ type: 'validatedIf', prop1, prop2 }, function (
    value,
    parentVm
  ) {
    return !helpers.ref(prop1, this, parentVm) &&
      !helpers.ref(prop2, this, parentVm)
      ? validator(value)
      : true
  })

export default {
  components: {
    DatePicker,
    VSelect,
    ToggleButton,
    ModalSuccess,
    ModalUnsuccessful,
    ModalPassword
  },

  props: {
    modal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      profile: JSON.parse(localStorage.getItem('profile')),
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD'
      },
      avatar: {
        url: '',
        base64: ''
      },
      dataApi: {
        company: [],
        workLocations: [],
        organization: [],
        workLocationActual: [],
        workUnit: [],
        role: [],
        companyRole: [],
        contractors: []
      },
      form: {
        company: {
          id: ''
        },
        role: {
          name: ''
        }
      },
      modalEdit: {
        textModal: '',
        success: false,
        unsuccessful: false,
        password: false
      },
      today: new Date(),
      isLoadingForm: false,
      isLoadingSave: false,
      customRole: []
    }
  },

  computed: {
    gender: () => GENDER,
    companyType: () => COMPANY_TYPE
  },

  watch: {
    'form.company.id' () {
      this.getWorkLocationActual(this.form.company.id)
      this.getContractors(this.form.company.id)
    }
  },

  mounted () {
    const idCompany = this.user.company ? this.user.company.id : ''
    this.initial()
    this.getCompany()
    this.getOrganization(idCompany)
    this.getWorkLocationActual(idCompany)
    this.getContractors(idCompany)
    this.getWorkUnit()
    this.getRole()
  },

  methods: {
    getReduceId: ({ id }) => id,
    getSelectableGroup: ({ group }) => !group,
    getReduceName: ({ name }) => name,
    getWorkUnitName: ({ workUnitName }) => workUnitName,
    getReduceValue: ({ value }) => value,
    getCompanyLabel ({ name }) {
      return this.$t(`company-detail.company.${name}`)
    },
    async initial () {
      this.isLoadingForm = true
      const data = await Api.users.get(this.user.id)
      this.form = data.data
      this.form.birthdate = format(new Date(this.form.birthdate), 'yyyy-MM-dd')
      if (!this.form.company) {
        this.form.company = {
          id: ''
        }
      }
      if (this.form.roleId === '23dc156d-5550-419a-a2e8-6bab249a8493') {
        this.initialMappingCompany(
          this.form.customAdminCompanyContractors,
          this.form.customAdminWorkLocations
        )
        this.initialMappingApi()
        this.initialMappingChild(
          this.form.customAdminCompanyContractors,
          this.form.customAdminWorkLocations
        )
      }
      this.isLoadingForm = false
    },
    async getCompany () {
      const data = await Api.masterData.companies()
      this.dataApi.company = data.data.data
      this.dataApi.companyRole = data.data.data.map(({ id, name }) => ({
        id: id,
        name: name,
        hide: false
      }))
      this.dataApi.company.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )
      this.dataApi.companyRole.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )
    },
    async getOrganization (id) {
      const { data } = await Api.masterData.workLocations({
        Filters: [`companyId==${id || ''}`, 'IsOrganization==true'].join(',')
      })
      this.dataApi.organization = data.data
    },
    async getContractors (id) {
      const data = await Api.masterData.contractors({
        Filters: `companyId==${id || ''}`
      })
      this.dataApi.contractors = data.data.data
      this.dataApi.contractors.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )
    },
    async getWorkLocationActual (id) {
      const { data } = await Api.masterData.workLocations({
        Filters: `companyId==${id || ''}`
      })
      this.dataApi.workLocationActual = data.data.reduce((acc, curr) => {
        const newGroup =
          (!acc.find(a => a.group === curr.category) && [
            { group: curr.category, name: null }
          ]) ||
          []
        return [...acc, ...newGroup, curr]
      }, [])
    },
    async getWorkUnit () {
      const dataWorkUnit = await Api.getWorkUnit()
      this.dataApi.workUnit = dataWorkUnit.data.data
      this.dataApi.workUnit.sort((a, b) =>
        a.workUnitName > b.workUnitName
          ? 1
          : b.workUnitName > a.workUnitName
            ? -1
            : 0
      )
    },
    getAge () {
      return differenceInYears(new Date(), new Date(this.form.birthdate))
    },
    onFileChange (e) {
      const file = e.target.files[0]
      this.avatar.url = URL.createObjectURL(file)
      this.selectedFiles = this.$refs.file.files[0]
      this.createBase64Image(file)
    },
    createBase64Image (fileObject) {
      const reader = new FileReader()
      reader.onload = e => {
        this.avatar.base64 = e.target.result
      }
      reader.readAsDataURL(fileObject)
    },
    getLabelGender ({ name }) {
      return this.$t(`user-profile.form.${name}`)
    },
    async submit () {
      let formRegister
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoadingSave = true
        if (this.form.hrisEmpId && this.form.isActiveDirectory) {
          formRegister = {
            address: this.form.address,
            phoneNumber: this.form.phoneNumber,
            workLocationActual: this.form.workLocationActual,
            isActive: this.form.isActive,
            roleId: this.form.roleId,
            comorbid: this.form.comorbid,
            contractorId: this.form.contractorId
          }
        }
        if (!this.form.hrisEmpId && this.form.isActiveDirectory) {
          formRegister = {
            birthdate: this.form.birthdate,
            gender: this.form.gender,
            address: this.form.address,
            phoneNumber: this.form.phoneNumber,
            companyId: this.form.company.id,
            workLocationActual: this.form.workLocationActual,
            nric: this.form.nric,
            workUnit: this.form.workUnit,
            isActive: this.form.isActive,
            roleId: this.form.roleId,
            comorbid: this.form.comorbid,
            contractorId: this.form.contractorId,
            workLocationId: this.form.workLocationId
          }
        }
        if (!this.form.hrisEmpId && !this.form.isActiveDirectory) {
          formRegister = {
            username: this.form.username,
            fullname: this.form.fullname,
            email: this.form.email,
            birthdate: this.form.birthdate,
            gender: this.form.gender,
            address: this.form.address,
            phoneNumber: this.form.phoneNumber,
            companyId: this.form.company.id,
            workLocationActual: this.form.workLocationActual,
            nric: this.form.nric,
            workUnit: this.form.workUnit,
            isActive: this.form.isActive,
            roleId: this.form.roleId,
            comorbid: this.form.comorbid,
            companyGroup: this.form.companyGroup,
            contractorId: this.form.contractorId,
            workLocationId: this.form.workLocationId
          }
        }
        if (this.avatar.base64) {
          formRegister.avatar = this.avatar.base64
        }
        if (this.form.roleId === '23dc156d-5550-419a-a2e8-6bab249a8493') {
          const mapping = this.mappingCustomAdmin()
          formRegister.CustomAdminCompanyContractors =
            mapping.mapContractorName
          if (mapping.mapOrganization.length) {
            formRegister.CustomAdminWorkLocations = mapping.mapOrganization
          }
        }
        if (this.form.roleId === '23dc156d-5550-419a-a2e8-6bab249a8493') {
          if (formRegister.CustomAdminCompanyContractors.length) {
            const data = await Api.users.put(this.form.id, formRegister)
            this.isLoadingSave = false
            if (data.status === 200) {
              this.modalEdit.textModal = this.$t(
                'user-management.update-text',
                { name: this.form.fullname }
              )
              this.showModal('success')
            } else if (data.status === 409) {
              if (this.$i18n.locale === 'en') {
                this.modalEdit.textModal = data.data.message.messageEng
              }
              if (this.$i18n.locale === 'id') {
                this.modalEdit.textModal = data.data.message.messageIdn
              }
              this.showModal('unsuccessful')
            }
          } else {
            this.isLoadingSave = false
            this.modalEdit.textModal = this.$t(
              'user-management.empty-custom-role'
            )
            this.showModal('unsuccessful')
          }
        } else {
          const data = await Api.users.put(this.form.id, formRegister)
          this.isLoadingSave = false
          if (data.status === 200) {
            this.modalEdit.textModal = this.$t('user-management.update-text', {
              name: this.form.fullname
            })
            this.showModal('success')
          } else if (data.status === 409) {
            if (this.$i18n.locale === 'en') {
              this.modalEdit.textModal = data.data.message.messageEng
            }
            if (this.$i18n.locale === 'id') {
              this.modalEdit.textModal = data.data.message.messageIdn
            }
            this.showModal('unsuccessful')
          }
        }
      }
    },
    showModal (modalname) {
      this.modalEdit[modalname] = true
    },
    closeModal (modalname) {
      this.modalEdit[modalname] = false
      if (modalname === 'success') {
        this.$emit('close', 'edit')
      }
    },
    async getRole () {
      const data = await Api.masterData.role()
      this.dataApi.role = data.data.data
    },
    addCustomRole () {
      this.$v.$reset()
      this.customRole.push({
        companyNew: null,
        companyOld: null,
        organization: null,
        contractorName: null,
        dataApi: {
          organization: [],
          contractorName: []
        }
      })
    },
    deleteCustomRole (index, idCompany) {
      if (idCompany) {
        const indexArr = this.dataApi.companyRole.findIndex(
          companyRole => companyRole.id === idCompany
        )
        this.dataApi.companyRole[indexArr].hide = false
      }
      this.customRole.splice(index, 1)
    },
    async updateField (index, idCompany) {
      if (this.customRole[index].companyOld) {
        const idCompanyOld = this.customRole[index].companyOld
        const indexArr = this.dataApi.companyRole.findIndex(
          companyRole => companyRole.id === idCompanyOld
        )
        this.dataApi.companyRole[indexArr].hide = false
      }

      const indexArr = this.dataApi.companyRole.findIndex(
        companyRole => companyRole.id === idCompany
      )
      this.dataApi.companyRole[indexArr].hide = true
      this.customRole[index].companyOld = idCompany

      this.customRole[index].dataApi.organization = []
      this.customRole[index].dataApi.contractorName = []
      this.customRole[index].organization = []
      this.customRole[index].contractorName = []
      const dataOrganization = await Api.masterData.workLocations({
        Filters: `companyId==${idCompany || ''}`
      })
      const dataContractor = await Api.masterData.contractors({
        Filters: `companyId==${idCompany || ''}`
      })
      this.customRole[index].dataApi.organization = dataOrganization.data.data
      this.customRole[index].dataApi.contractorName = dataContractor.data.data
      this.customRole[index].dataApi.contractorName.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )
    },
    initialMappingCompany (arrMappingCon, arrMappingWork) {
      for (let i = 0; i < arrMappingCon.length; i++) {
        const found = this.customRole.findIndex(
          element => element.companyNew === arrMappingCon[i].companyId
        )
        if (found === -1) {
          this.customRole.push({
            companyNew: arrMappingCon[i].companyId,
            companyOld: arrMappingCon[i].companyId,
            organization: [],
            contractorName: [],
            dataApi: {
              organization: [],
              contractorName: []
            }
          })
        }
      }
      for (let i = 0; i < arrMappingWork.length; i++) {
        const found = this.customRole.findIndex(
          element => element.companyNew === arrMappingWork[i].companyId
        )
        if (found === -1) {
          this.customRole.push({
            companyNew: arrMappingWork[i].companyId,
            companyOld: arrMappingWork[i].companyId,
            organization: [],
            contractorName: [],
            dataApi: {
              organization: [],
              contractorName: []
            }
          })
        }
      }
    },
    async initialMappingApi () {
      for (let i = 0; i < this.customRole.length; i++) {
        const dataContractor = await Api.masterData.contractors({
          Filters: `companyId==${this.customRole[i].companyNew || ''}`
        })
        const dataOrganization = await Api.masterData.workLocations({
          Filters: `companyId==${this.customRole[i].companyNew || ''}`
        })
        this.customRole[i].dataApi.contractorName = dataContractor.data.data
        this.customRole[i].dataApi.organization = dataOrganization.data.data
      }
    },
    initialMappingChild (arrMappingCon, arrMappingWork) {
      for (let i = 0; i < arrMappingCon.length; i++) {
        const found = this.customRole.findIndex(
          element => element.companyNew === arrMappingCon[i].companyId
        )
        if (arrMappingCon[i].contractorId) {
          this.customRole[found].contractorName.push(
            arrMappingCon[i].contractorId
          )
        }
      }
      for (let i = 0; i < arrMappingWork.length; i++) {
        const found = this.customRole.findIndex(
          element => element.companyNew === arrMappingWork[i].companyId
        )
        if (arrMappingWork[i].workLocationId) {
          this.customRole[found].organization.push(
            arrMappingWork[i].workLocationId
          )
        }
      }
    },
    mappingCustomAdmin () {
      const mapOrganization = []
      const mapContractorName = []
      for (let i = 0; i < this.customRole.length; i++) {
        if (this.customRole[i].contractorName.length) {
          for (let k = 0; k < this.customRole[i].contractorName.length; k++) {
            mapContractorName.push({
              companyId: this.customRole[i].companyNew,
              contractorId: this.customRole[i].contractorName[k]
            })
          }
        } else {
          const found = mapContractorName.findIndex(
            element => element.companyId === this.customRole[i].companyNew
          )
          if (found === -1) {
            mapContractorName.push({
              companyId: this.customRole[i].companyNew,
              contractorId: null
            })
          }
        }
        if (this.customRole[i].organization.length) {
          for (let k = 0; k < this.customRole[i].organization.length; k++) {
            mapOrganization.push({
              companyId: this.customRole[i].companyNew,
              workLocationId: this.customRole[i].organization[k]
            })
          }
        } else {
          const found = mapContractorName.findIndex(
            element => element.companyId === this.customRole[i].companyNew
          )
          if (found === -1) {
            mapContractorName.push({
              companyId: this.customRole[i].companyNew,
              contractorId: null
            })
          }
        }
      }

      return {
        mapOrganization,
        mapContractorName
      }
    }
  },

  validations: {
    form: {
      username: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId && !this.form.isActiveDirectory
        }),
        alpha: helpers.regex(
          alpha,
          /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/i
        ),
        minLength: validateIf('hrisEmpId', 'isActiveDirectory', minLength(8)),
        maxLength: maxLength(20)
      },
      fullname: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId && !this.form.isActiveDirectory
        })
      },
      birthdate: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId
        })
      },
      gender: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId
        })
      },
      email: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId && !this.form.isActiveDirectory
        }),
        email
      },
      address: {
        required
      },
      phoneNumber: {
        required,
        numeric: helpers.regex(numeric, /^[+0-9]*$/i)
      },
      companyGroup: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId && !this.form.isActiveDirectory
        })
      },
      company: {
        id: {
          required: requiredIf(function () {
            return !this.form.hrisEmpId
          })
        }
      },
      workLocationActual: {
        required
      },
      nric: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId
        })
      },
      workUnit: {
        required: requiredIf(function () {
          return !this.form.hrisEmpId
        })
      },
      roleId: {
        required
      }
    },
    customRole: {
      $each: {
        companyNew: {
          required
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  display: flex;
  background-color: rgba(87, 85, 85, 0.473);
  padding-left: 0;
  z-index: 10;
}
.card {
  margin: 0 auto;
  width: 800px;
  border-radius: 18px;
}
.card-body {
  height: 400px;
}
.border-bottom {
  border-bottom: 2px solid #dedede !important;
}
.pointer {
  cursor: pointer;
}
input[type="file"] {
  display: none;
}
.parent-button {
  position: relative;
  display: inline-block;
}
.children-button {
  position: absolute;
  top: 60px;
  left: 70px;
  z-index: 1;
}
.image-width {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.bg-secondary {
  background-color: #e9ecef !important;
}
.role-card {
  height: 370px;
  border-left: 2px solid #dedede;
  border-right: 2px solid #dedede;
  box-shadow: 2px 8px #88888838;
}
.table-height {
  height: 280px;
  width: 1000px;
}
.table-wrapper {
  overflow-y: scroll;
  height: 150px;
}
.table-wrapper th {
  position: sticky;
  top: 0;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #8decf321;
}
.in-front-of {
  z-index: 10;
}

/deep/ .vs__dropdown-toggle {
  background: white;
}

/deep/ .vs__selected-options {
  flex-wrap: nowrap;

  .vs--open & {
    flex-wrap: wrap;
  }
}
</style>
